<template>
  <div class="mm-dialog" :class="[type]">
    <div v-if="type !== 'modal' && title" class="head">
      <span class="title">{{ title }}</span>
      <p class="customer-template" v-if="customer_template_code">
        当前主题：<span>{{ customer_template_code }}</span>
      </p>
      <span class="oo" v-if="showClose" @click="$emit('close')">
        <i class="iconfont icon-guanbi" />
      </span>
    </div>
    <div class="body">
      <template v-if="type === 'modal'">
        <div class="title">
          <span class="iconfont icon-zhuyi" />
          <span>{{ title }}</span>
        </div>
        <div class="desc">{{ desc }}</div>
        <div class="action">
          <el-button type="primary" plain @click="$emit('close')">取消</el-button>
          <el-button
            type="primary"
            @click="
              () => {
                $emit('close')
                $emit('ok')
              }
            "
            >继续</el-button
          >
        </div>
      </template>
      <slot v-else />
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  title: {
    type: String,
    required: false,
    default: undefined
  },
  desc: {
    type: String,
    required: false,
    default: undefined
  },
  type: {
    type: String,
    required: false,
    default: undefined
  },
  showClose: {
    type: Boolean,
    required: false,
    default: true
  },
  customer_template_code: {
    type: String,
    required: false,
    default: ''
  }
})
</script>

<style lang="scss">
.mm-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 199;
  transform: translateX(-50%) translateY(-50%);
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  border: 1px solid #e3e2e8;
  overflow: hidden;
  &.middle {
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  &.modal {
    width: 430px;
    .body {
      padding: 30px;
      .title {
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        line-height: 26px;
        span:first-child {
          margin-right: 10px;
          font-size: 20px;
          color: #ff8400;
        }
      }
      .desc {
        margin-top: 4px;
        padding-left: 30px;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 26px;
      }
      .action {
        margin-top: 24px;
        text-align: right;
      }
    }
  }
  > .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 20px;
    border-bottom: 2px solid #f2f2f3;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 1;
    .oo {
      transition: 0.3s;
      cursor: pointer;
      &:hover {
        transform: rotate(90deg);
      }
      .iconfont {
        font-size: 11px;
      }
    }
  }
  > .body {
    padding: 20px 20px;
  }
}
</style>

<style lang="scss" scoped>
.templateLibraryModal {
  .head {
    .title {
      border-left: 4px solid var(--el-color-primary);
      padding-left: 10px;
      font-size: 18px;
      font-weight: bold;
    }
    .customer-template {
      flex: 1;
      margin-left: 30px;
      span {
        color: var(--el-color-primary);
      }
    }
  }
}
</style>
